import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const LoadingIcon = (props: SvgIconProps) => (
  <LoopOutlinedIcon
    {...props}
    fontSize="small"
    className="animate-spin"
    style={{
      ...props.style,
      animationDirection: "reverse",
    }}
  />
);

export default LoadingIcon;
